

(function( ){


//------------------------------------------------------------------------------------------------------------------------------


	var ImageModalConfig =
	{
		autoInit:true ,
		className:"js-img-modal" ,
		dataSrc:"data-src" ,
		dataWidth:"data-width" ,
		dataHeight:"data-height" ,
		background:"rgba(0,0,0,0.75)" ,
		closeButton:{ url:"./assets/benzaiten_common/img/sp/common/modal_close.png" , width:142*0.7+"px" , height:"auto" } ,
		loop:false
	}


//------------------------------------------------------------------------------------------------------------------------------


	var ImageModal = function( )
	{
		var html = document.body.parentNode ;
		var body = document.body ;

		var _this = YTVideoModal = this ;
		var i;


		//     -     -     -     -     -     -     -     -     -     -


		var _root = document.createElement("div") ;
		_root.className = "js-modal" ;
		_root.style.opacity = 0 ;

		var bg = document.createElement("div") ;
		bg.className = "js-modal-bg" ;

		var scroll = document.createElement("div") ;
		scroll.className = "js-modal-scroll" ;

		var con = document.createElement("div") ;
		con.className = "con" ;

		var btn_close = document.createElement("div") ;
		btn_close.className = "wrapper-btn-close" ;

		var btn_close_img = document.createElement("img") ;
		btn_close_img.className = "btn-close" ;
		btn_close_img.src = ImageModalConfig.closeButton.url ;

		var img = document.createElement("img") ;
		img.className = "img" ;

		var imgSize = {
			x:0 ,
			y:0 ,
			w:640 ,
			h:360 ,
			scale:0 ,
			ratio:0
		} ;
		var imgDataSize = { w:0 , h:0 } ;


		//     -     -     -     -     -     -     -     -     -     -


		setParams( _root.style , { 	zIndex:1000 , position:"fixed" ,
									width:"100%" , height:"100%" ,
									left:"0px" , top:"0px" } ) ;

		setParams( bg.style , { position:"absolute" ,
								width:"100%" , height:"100%" ,
								background:ImageModalConfig.background ,
								left:"0px" , top:"0px" } ) ;

		setParams( scroll.style , { position:"absolute" , width:"100%" , height:"100%" ,
									borderTop:"solid 1px transparent" , overflow:"auto" , left:"0px" , top:"0px" } ) ;

		setParams( con.style , { 	position:"relative" , width:"auto" , height:"auto" ,
									margin:"20px 0 " , marginTop:"19px" , borderTop:"solid 1px transparent" } ) ;

		setParams( btn_close.style , { 	cursor:"pointer" , position:"relative" , textAlign:"right" ,
										width:"100%" , right:"0px" , top:"0px" , margin:"0 auto 20px" } ) ;
		setParams( btn_close_img.style , { 	position:"relative" , display:"inline-block" , pointerEvents:"auto" ,
											width:ImageModalConfig.closeButton.width , height:ImageModalConfig.closeButton.height ,
											right:"0px" , top:"0px" , marginBottom:"0px" } ) ;

		setParams( img.style , { 	position:"relative" , left:"0px" , top:"0px" , right:"0px" , margin:"0 auto 0" ,
											width:"100%" , height:"auto" , display:"block" } ) ;

		var style = document.createElement( "style" ) ;
		document.body.appendChild( style ) ;
		// style.innerHTML =
		// // PC
		// "@media screen and (min-width:737px){ .js-modal .js-modal-scroll .img{" +
		// "max-width:100px;" +
		// "} }" +
		// // SP
		// "@media screen and (max-width:736px){ .js-modal .js-modal-scroll .img{" +
		// "max-width:100px;" +
		// "} }" ;

		//     -     -     -     -     -     -     -     -     -     -

		_root.appendChild( bg ) ;
		_root.appendChild( scroll ) ;

		btn_close.appendChild( btn_close_img ) ;

		con.appendChild(btn_close) ;
		con.appendChild(img) ;

		scroll.appendChild( con ) ;

		//     -     -     -     -     -     -     -     -     -     -


		// var onResize = function( )
		// {
		// 	// var htmlWidth = html.offsetWidth ;
		// 	// var htmlHeight = html.offsetHeight ;

		// 	// imgSize.scale = Math.max( imgDataSize.w / (htmlWidth - 40) , imgDataSize.h / (htmlHeight - 40 - 80 - 20 ) ) ;

		// 	// if( imgSize.scale < 1 )		imgSize.scale = 1 ;

		// 	// imgSize.w = imgDataSize.w / imgSize.scale ;
		// 	// imgSize.h = imgDataSize.h / imgSize.scale ;
		// 	// imgSize.x = ((htmlWidth - 40) - imgSize.w) / 2 ;
		// 	// imgSize.y = ((htmlHeight - 40 - 80 ) - imgSize.h) / 2 ;

		// 	//

		// 	// con.style.width = imgSize.w + "px" ;
		// 	// con.style.height = imgSize.h + "px" ;
		// 	// con.style.left = imgSize.x + "px" ;
		// 	// con.style.top = imgSize.y + "px" ;

		// 	//
		// }
		// onResize( ) ;
		// window.addEventListener( "resize" , onResize ) ;


		//     -     -     -     -     -     -     -     -     -     -


		var onOpen = function( evt )
		{
			evt.preventDefault( ) ;

			_this.openModal( evt.currentTarget ) ;
		}

		var onClose = function( evt )
		{
			switch( evt.type )
			{
				case "click" :
					_this.closeModal( ) ;
					btn_close_img.style.opacity = 1 ;
					break ;

				case "mouseover" :
					btn_close_img.style.opacity = 0.6 ;
					break ;

				case "mouseout" :
					btn_close_img.style.opacity = 1 ;
					break ;
			}
		}
		btn_close_img.style.opacity = 1 ;

		var removeContent = function( )
		{
			_root.parentNode.removeChild( _root ) ;
			// wrapper_img.innerHTML = "" ;
		}

		bg.addEventListener( "click", onClose ) ;
		btn_close_img.addEventListener( "click" , onClose ) ;
		btn_close_img.addEventListener( "mouseover" , onClose ) ;
		btn_close_img.addEventListener( "mouseout" , onClose ) ;


		//     -     -     -     -     -     -     -     -     -     -


		var addedList = [] ;
		_this.add = function( target )
		{
			addedList.push( target ) ;
			target.addEventListener( "click" , onOpen ) ;
		}


		//


		_this.openModal = function( target )
		{
			// imgDataSize.w = target.getAttribute( ImageModalConfig.dataWidth ) ;
			// imgDataSize.h = target.getAttribute( ImageModalConfig.dataHeight ) ;


			//     -     -     -     -     -     -     -     -     -     -


			// onResize( ) ;
			style.innerHTML =
			// PC
			"@media screen and (min-width:737px){ .js-modal .js-modal-scroll .img , .js-modal .js-modal-scroll .wrapper-btn-close {" +
			"max-width:" + target.getAttribute( "data-width-pc" )  + "px;" +
			"} }" +
			// SP
			"@media screen and (max-width:736px){ .js-modal .js-modal-scroll .img , .js-modal .js-modal-scroll .wrapper-btn-close {" +
			"max-width:" + target.getAttribute( "data-width-sp" )  + "px;" +
			"} }" ;



			if( _root.parentNode ) return ;

			body.style.overflow = "hidden" ;

			img.src = target.getAttribute( ImageModalConfig.dataSrc ) ;

			body.appendChild(_root) ;

			opacityTween( 1 , 0.15 ) ;
		}

		_this.closeModal = function( )
		{
			if( body.style.overflow == "" ) return ;

			body.style.overflow = "" ;

			opacityTween( 0 , -0.15 , removeContent ) ;
		}


		//


		var opacityTween = function( to , vector , onComplete )
		{
			opacityTween.to = to ;
			opacityTween.vector = vector ;
			opacityTween.onComplete = onComplete ;
			opacityTween.act( ) ;
		}
		opacityTween.opacity = 0 ;
		opacityTween.to = 0 ;
		opacityTween.vector = 0 ;
		opacityTween.requestID = null ;
		opacityTween.onComplete = null ;
		opacityTween.act = function( )
		{
			opacityTween.requestID = window.requestAnimationFrame( opacityTween.act ) ;

			opacityTween.opacity += opacityTween.vector ;

			if( opacityTween.vector < 0 )
			{
				if( opacityTween.opacity <= opacityTween.to )	opacityTween.opacity = opacityTween.to ;
			}
			else
			{
				if( opacityTween.opacity >= opacityTween.to )	opacityTween.opacity = opacityTween.to ;
			}

			_root.style.opacity = opacityTween.opacity ;

			if( opacityTween.opacity == opacityTween.to )
			{
				window.cancelAnimationFrame( opacityTween.requestID ) ;
				if( opacityTween.onComplete )	opacityTween.onComplete( ) ;
			}
		}


		//     -     -     -     -     -     -     -     -     -     -


		_this.dispose = function( )
		{
			if( addedList.length )
			{
				for( i = 0 ; i < addedList.length ; i++ )
				{
					addedList[i].removeEventListener( "click" , onOpen ) ;
				}
				addedList = [ ] ;
			}
		}

		_this.parse = function( )
		{
			_this.dispose( ) ;

			//

			var autoSettingTarget = document.getElementsByClassName( ImageModalConfig.className ) ;

			for( i = 0 ; i < autoSettingTarget.length ; i++ )
			{
				_this.add( autoSettingTarget[i] ) ;
			}
		}
		_this.parse( ) ;


		//     -     -     -     -     -     -     -     -     -     -
	}


//------------------------------------------------------------------------------------------------------------------------------


	var setParams = function( target , initObj , execution )
	{
		if( target instanceof Array )
		{
			for( var i in target )		setParams( target[i] , initObj ) ;
			return ;
		}

		//    -    -    -    -    -    -    -    -    -

		if( target && initObj )
		{
			for( var paramStr in initObj )
			{
				if( execution || target[paramStr] != undefined )
				{
					if( initObj[paramStr] instanceof Function )
					{
						target[paramStr] = initObj[paramStr] ;
					}
					else if( initObj[paramStr] instanceof Object )
					{
						setParams( target[paramStr] , initObj[paramStr] ) ;
					}
					else
					{
						target[paramStr] = initObj[paramStr] ;
					}
				}
			}
		}
	}


//------------------------------------------------------------------------------------------------------------------------------


	window.requestAnimationFrame = 	window.requestAnimationFrame ||
									window.webkitRequestAnimationFrame ||
									window.mozRequestAnimationFrame	||
									window.msRequestAnimationFrame ||
									window.oRequestAnimationFrame ||
									function( func ){ return setTimeout( func , 1000/60 ) ; } ;

	window.cancelAnimationFrame = 	window.cancelAnimationFrame ||
									window.webkitCancelAnimationFrame ||
									window.mozCancelAnimationFrame ||
									window.msCancelAnimationFrame ||
									window.oCancelAnimationFrame ||
									function( id ){ clearTimeout( id ) ; } ;


	if( ImageModalConfig.autoInit )
	{
		document.readyState === "complete"
			? setTimeout( function(){ new ImageModal( ) ; }  , 1 )
			: document.addEventListener( "DOMContentLoaded", function(){ new ImageModal( ) ; }  ) ;
	}


//-------------------------------------------------------------------------------------------------------------------------------


} )( ) ;
